import React, { memo, useCallback, useMemo } from 'react';
import { Row } from 'react-table';
import { StyledNextTable } from '../styled';

type NextTableRowProps = { row: any; prepareRow: (row: Row<any>) => void; getRowProps?: Function; selected?: boolean };

export const NextTableRow = memo<NextTableRowProps>(({ prepareRow, row, getRowProps }) => {
  prepareRow(row);
  const toggleRowSelectedProps = row.getToggleRowSelectedProps();
  const handleClick = useCallback(() => {
    toggleRowSelectedProps.onChange({ target: { checked: !toggleRowSelectedProps.checked } });
  }, [toggleRowSelectedProps]);
  const extraProps = useMemo(() => (getRowProps ? getRowProps(row.id, row.original) : {}), [getRowProps, row.id, row.original]);
  const { key: rowKey, ...rowProps } = row.getRowProps({ onClick: handleClick, ...extraProps });
  return (
    <StyledNextTable.Tr key={rowKey} $selected={toggleRowSelectedProps.checked} {...rowProps}>
      {row.cells.map((cell: any) => {
        const { key: cellKey, ...cellProps } = cell.getCellProps({ className: cell.column.className });
        return (
          <StyledNextTable.Td key={cellKey} {...cellProps}>
            {cell.render('Cell')}
          </StyledNextTable.Td>
        );
      })}
    </StyledNextTable.Tr>
  );
});
